<template>
    <div class="footer-area">

        <div class=" footer">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-6 wow fadeInRight animated">
                        <div class="single-footer">
                            <h4>Quick links </h4>
                            <div class="footer-title-line"></div>
                            <ul class="footer-menu">
                                <li><router-link to="/properties">Properties</router-link>  </li>
                                <li><router-link to="/submit-property">Submit property </router-link></li>
                                <li><router-link to="/contact">Contact us</router-link></li>
                                <li><router-link to="register">Create account</router-link>  </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 wow fadeInRight animated">
                        <div class="single-footer news-letter">
                            <h4>Stay in touch</h4>
                            <div class="footer-title-line"></div>

                            <form>
                                <div class="input-group">
                                    <input class="form-control" type="text" placeholder="E-mail ... ">
                                    <span class="input-group-btn">
                                            <button class="btn btn-primary subscribe" type="button"><i class="pe-7s-paper-plane pe-2x"></i></button>
                                        </span>
                                </div>
                                <!-- /input-group -->
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="footer-copy text-center">
            <div class="container">
                <div class="row">
                    <div class="pull-left">
                        <span> (C) , All rights reserved {{ (new Date()).getFullYear()}}  </span>
                    </div>
                    <div class="bottom-menu pull-right">
                        <ul>
                            <li><router-link to="/" class="wow fadeInUp animated" data-wow-delay="0.2s">Home</router-link></li>
                            <li><router-link to="/contact" class="wow fadeInUp animated" data-wow-delay="0.6s">Contact</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped>

</style>
